import BallotIcon from '@material-ui/icons/Ballot';
import CookingList from "./CookingList";
import CookingCreate from "./CookingCreate";
import CookingEdit from "./CookingEdit";
import CookingShow from "./CookingShow";

export default {
    icon: BallotIcon,
    list: CookingList,
    create: CookingCreate,
    edit: CookingEdit,
    show: CookingShow
}